// @ts-nocheck
import { useState } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { setDefaultRatings } from 'state/slices/commonSlice';
import { RATING_COLORS } from 'const/Const';
import SwalToast from 'components/Common/SwalToast';
import { API_ENDPOINTS } from '../const/ApiEndpoints';
import useDashBoard from './useDashboard';
import { CoreUtils } from '../utils/Utils';

/**
 * @function useRiskRating
 * @description a custom hook which handles APIs related to Risk Rating screen
 * @returns {object} object
 */
export default function useRiskRating() {
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [riskList, setRiskList] = useState();
  const [systemRisk, setSystemRisk] = useState([]);
  const [riskValue, setRiskValue] = useState();
  const [riskResult, setRiskResult] = useState([]);
  const [riskResponse, setRiskResponse] = useState([]);
  const [riskDasboardData, setRiskDashboardData] = useState([]);
  const [selectedSearchRatings, setSelectedSearchRatings] = useState([]);

  const [riskRatingChartData, setRiskRatingChartData] = useState([]);
  const { userTypes, analystType } = useDashBoard();
  const [riskRatingChartByParameter, setRiskRatingChartByParameter] = useState(
    []
  );
  const [riskRatingMigrationMatrixData, setRiskRatingMigrationMatrixData] =
    useState([]);
  const userData = useSelector((state) => state.common.userData);
  /**
   * @function fetchRiskList
   * @description A function to fetch risk List
   * @returns {Promise} returns an axios promise
   */
  const fetchRiskList = (queryParams) => {
    setIsLoading(true);
    axios
      .get(`${API_ENDPOINTS.CALCULATE_RISK_RATING}`, {
        params: {
          screen_type: queryParams.screen_type,
          search_id: queryParams.id,
          list_type: 'risk_rating',
        },
      })
      .then((response) => {
        setRiskResponse(response?.data);
        setSystemRisk(response?.data?.system_generated_rr_values);
        setRiskList(response?.data?.risk_rating_values);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        throw err;
      });
  };

  /**
   * @function calculateRiskRating
   * @description A function to calculate risk rating
   * @returns {Promise} returns an axios promise
   */
  const calculateRiskRating = (data) => {
    setIsLoading(true);
    return axios
      .post(`${API_ENDPOINTS.CALCULATE_RISK_RATING}`, {
        screen_type: data?.screen_type,
        search_id: data?.search_id,
        risk_rating_values: data?.riskList,
        search_type: data?.search_type,
      })
      .then((response) => {
        setIsLoading(false);
        setRiskValue(response?.data?.risk_rating);
        setRiskResult(response?.data?.data);
        enqueueSnackbar(response?.data?.msg, {
          variant: 'success',
        });
      })
      .catch((err) => {
        setIsLoading(false);
        throw err;
      });
  };
  const fetchRiskRatingDashboardValue = (data) => {
    const queryParam = {
      ...data,
    };
    setIsLoading(true);
    return axios
      .get(API_ENDPOINTS.RISK_RATING_DASHBOARD, {
        params: queryParam,
      })
      .then(
        (response) => {
          setIsLoading(false);
          setRiskDashboardData(response?.data);
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  const fetchRiskRatingChartdValue = (data) => {
    const queryParam = {
      screen_type: data?.screen_type,
      search_type: data?.search_type !== '' ? data?.search_type : null,
      start_date: data?.start_date !== '' ? data?.start_date : null,
      end_date: data?.end_date !== '' ? data?.end_date : null,
      analyst_id: data?.analyst ? data?.analyst : null,
      manager_id: data?.manager ? data?.manager : null,
      team_id: data?.team ? data?.team : null,
      search_source: data?.search_source || '',
    };
    setIsLoading(true);
    return axios
      .get(API_ENDPOINTS.RISK_RATING_DASHBOARD_CHART, { params: queryParam })
      .then(
        (response) => {
          setIsLoading(false);
          setRiskRatingChartData(response?.data);
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  const fetchRiskRatingChartByParameter = (data) => {
    const queryParam = {
      analyst_id: data?.analyst,
    };
    setIsLoading(true);
    return axios
      .get(API_ENDPOINTS.RISK_RATING_DASHBOARD_CHART_BY_PARAMETER, {
        params: queryParam,
      })
      .then(
        (response) => {
          setIsLoading(false);
          setRiskRatingChartByParameter(response?.data);
        },
        () => {
          setIsLoading(false);
        }
      );
  };
  const fetchMigrationMatrix = (data) => {
    const queryParam = {
      ...data,
    };
    setIsLoading(true);
    return axios
      .get(API_ENDPOINTS.RISK_RATING_DASHBOARD_MIGRATION_MATRIX, {
        params: queryParam,
      })
      .then(
        (response) => {
          setIsLoading(false);
          setRiskRatingMigrationMatrixData(response?.data);
          return response;
        },

        () => {
          setIsLoading(false);
        }
      );
  };
  const getMigrationMatrixData = ({ page = 0, pageSize = 5, filters }) => {
    const modifiedFilters = CoreUtils.buildModifiedFilters(filters);

    const params = {
      pageCount: page + 1,
      pageSize,
      table: true,
      graph: true,
      previous_risk_rating: modifiedFilters?.previous_risk_rating || '',
      current_risk_rating: modifiedFilters?.current_risk_rating || '',
      search_type:
        modifiedFilters?.search_type !== ''
          ? modifiedFilters?.search_type
          : null,
      start_date:
        modifiedFilters?.initiatedStartDate !== ''
          ? modifiedFilters?.initiatedStartDate
          : null,
      end_date:
        modifiedFilters?.initiatedEndDate !== ''
          ? modifiedFilters?.initiatedEndDate
          : null,
      analyst_id:
        userData?.user_type === 'maker' || userData?.user_type === 'checker'
          ? userData?.id
          : modifiedFilters?.analyst,
      manager_id: modifiedFilters?.manager,
      team_id: modifiedFilters?.team,
      search_source: modifiedFilters?.search_source || '',
    };
    return axios
      .get(API_ENDPOINTS.RISK_RATING_DASHBOARD_MIGRATION_MATRIX, {
        params,
        loader: false,
      })
      .then((res) => {
        setRiskRatingMigrationMatrixData(res.data);
        return {
          data: res.data?.table_data,
          totalRowCount: res.headers?.['x-total-count'],
        };
      });
  };

  /**
   * @function processRiskRatingsData
   * @description A helper function to process and transform risk ratings data
   * @param {Object} data - The raw risk ratings data from API response
   * @returns {Array} Processed and sorted risk ratings data
   */
  const processRiskRatingsData = (data) => {
    const sortedData = _(data)
      .toPairs()
      .map(([label, v]) => ({ min: v.from, max: v.to, label }))
      .sortBy(['min', 'max'])
      .reverse()
      .map((item, index) => {
        const labelLower = item.label.toLowerCase();
        const isLowType =
          labelLower === 'low' || labelLower === 'moderately_low';
        const isMediumType =
          labelLower === 'medium' || labelLower === 'moderately_high';

        let id = index;
        if (isLowType) id = 0;
        else if (isMediumType) id = 1;

        return {
          id,
          isDefault: ['low', 'medium', 'high'].includes(labelLower),
          color: RATING_COLORS[item.label] || '',
          ...item,
        };
      })
      .value();

    return sortedData;
  };

  const getRiskRatings = () => {
    return axios.get(API_ENDPOINTS.RISK_RATING_LEVELS).then((res) => {
      const processedData = processRiskRatingsData(res.data);
      dispatch(setDefaultRatings(processedData));
      return processedData;
    });
  };

  const getRiskRatingsForSearch = ({ searchId, type = 'initial' }) => {
    return axios
      .get(`${API_ENDPOINTS.RISK_RATING_LEVELS}${type}/${searchId}`)
      .then((res) => {
        const processedData = processRiskRatingsData(res.data);
        setSelectedSearchRatings(processedData);
        return processedData;
      });
  };

  const configureRiskRatings = (id, payload) => {
    return axios
      .patch(`${API_ENDPOINTS.RULE_ENGINE_SUPPRESSION_LOGIC}${id}/`, {
        ...payload,
      })
      .then(() => {
        SwalToast({
          icon: 'success',
          title: 'Risk ratings configured successfully',
        });
      });
  };

  return {
    fetchRiskList,
    calculateRiskRating,
    riskList,
    riskValue,
    riskResult,
    setRiskValue,
    setRiskList,
    systemRisk,
    setSystemRisk,
    riskResponse,
    fetchRiskRatingDashboardValue,
    userTypes,
    analystType,
    riskDasboardData,
    riskRatingChartData,
    fetchRiskRatingChartdValue,
    fetchRiskRatingChartByParameter,
    riskRatingChartByParameter,
    fetchMigrationMatrix,
    riskRatingMigrationMatrixData,
    isLoading,
    getMigrationMatrixData,
    getRiskRatings,
    getRiskRatingsForSearch,
    selectedSearchRatings,
    configureRiskRatings,
  };
}
